var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "标签宽度(cm)" } },
        [
          _c("el-input-number", {
            staticClass: "setting-label_width",
            attrs: {
              "controls-position": "right",
              placeholder: "请输入标签宽度",
              precision: _vm.precision,
              step: _vm.step,
              min: 0,
              max: 10
            },
            model: {
              value: _vm.labelWidth,
              callback: function($$v) {
                _vm.labelWidth = _vm._n($$v)
              },
              expression: "labelWidth"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-694735b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694735b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/style_setting/SettingLabelWidth.vue
// module id = null
// module chunks = 